const remainingDays = (hours) => Math.floor(hours / (1000 * 60 * 60 * 24));
const remainingHours = (minutes) => Math.floor(((minutes % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
const remainingMinutes = (seconds) => Math.floor((seconds % (1000 * 60 * 60)) / (1000 * 60));
const remainingSeconds = (data) => Math.floor((data % (1000 * 60)) / 1000);


export {remainingDays, remainingHours, remainingMinutes, remainingSeconds}